import React from 'react';
import './About.css';
import micImage from './mic.jpeg';
import jacobImage from './jacob.jpg';
import hamidrezaImage from './hamidreza.jpg';

function About({handleClose}) {
  return (
    <div className="about-page">
      <button onClick={handleClose} className="close-button">Close</button>
      <h1>About Urban Video Archive</h1>
      <p>
        The Urban Video Archive project builds a prototype to preserve videos from grassroots video activists in Brazil. In close collaboration with Mídia Independente Coletiva from Rio de Janeiro, we are developing a methodology to ensure that the videos about protests and police violence, which disproportionately target Afrobrazilians, indigenous citizens, and residents of Favelas, remain visible for future generations. The preservation and contextualization of these videos through audiovisual micro-narratives and thoughtful curation allow outsiders access to urban lifeworlds that are marginalized across scales. The 119 videos of the collection report about forced evictions, the trauma inflicted on families who lose their children in police attacks, and structural violence against marginalized urban citizens. To amplify the voices from the urban margins and document the cracks in the urban fabric is a key element to envision concrete utopias of emancipation. Listening to the voices and experiences captured in the videos grounds initiatives for more democratic and radical forms of bottom-up city making in the future, informed by past experiences recorded and told from the urban margins.
      </p>

      <h2>Creators</h2>

      <div className="creator-card">
        <img className="creator-image" src={micImage} alt="Mídia Independente Coletiva" />
        <p>Mídia Independente Coletiva (Media Production and Collection)</p>
      </div>

      <div className="creator-card">
        <img className="creator-image" src={jacobImage} alt="Jacob Geuder" />
        <p>Jacob Geuder (Data Collection, Data Analysis, and Design)  <a href="mailto:jacob.geuder@unibas.ch">Contact</a></p>
      </div>

      <div className="creator-card">
        <img className="creator-image" src={hamidrezaImage} alt="Hamidreza Nassiri" />
        <p>Hamidreza Nassiri (Data Analysis, Design, and App Development)  <a href="mailto:hnassiri@fordham.edu">Contact</a></p>
      </div>
    </div>
  );
}

export default About;
